import './App.css';
import React, { useState, useEffect } from 'react';

import { BrowserRouter, Routes, Route, Navigate, useParams} from 'react-router-dom';
import Dashboard from './components/pages/Dashboard';
import Token from './components/pages/Token';
import Navbar from './common/Navbar';
import Swap from './components/pages/Swap';
import Popups from './components/common/Popups';
import Hardlock from './components/pages/Hardlock';
import Hardstake from './components/pages/Hardstake';
import Launch from './components/pages/Launch';
import CreateToken from './components/pages/CreateToken';
import Lending from './components/pages/Lending';
const VALID_CHAINS = ['ethereum', 'base','bsc','sonic'];

// Validation Wrapper Component
function ChainValidator({ children }) {
  const { chain } = useParams();
  if (!VALID_CHAINS.includes(chain)) {
    return <Navigate replace to="/ethereum" />;
  }
  return children;
}

function App() {
  const [signer, setSigner] = useState(null);

  const updateSigner = async (signerInstance) => {
    setSigner(signerInstance)
  };
  
  return (
    <div className="App">
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Popups />

        <Navbar updateSigner={updateSigner} />
        <Routes>
          {/* Wrap routes that need chain validation */}

          <Route
            path="/:chain"
            element={
              <ChainValidator>
                <Dashboard />
              </ChainValidator>
            }
          />
          <Route
            path="/:chain/swap"
            element={
              <ChainValidator>
                <Swap signer={signer} />
              </ChainValidator>
            }
          />
          <Route
            path="/:chain/hardlock"
            element={
              <ChainValidator>
                <Hardlock  signer={signer} />
              </ChainValidator>
            }
          />
          <Route
            path="/:chain/hardstake"
            element={
              <ChainValidator>
                <Hardstake  signer={signer} />
              </ChainValidator>
            }
          />
          <Route
            path="/:chain/launch"
            element={
              <ChainValidator>
                <Launch  signer={signer} />
              </ChainValidator>
            }
          />
          <Route
            path="/:chain/create-token"
            element={
              <ChainValidator>
                <CreateToken  signer={signer} />
              </ChainValidator>
            }
          />
          <Route
            path="/:chain/token/:tokenAddress"
            element={
              <ChainValidator>
                <Token  signer={signer} />
              </ChainValidator>
            }
          />
          <Route
            path="/:chain/lending"
            element={
              <ChainValidator>
                <Lending  signer={signer} />
              </ChainValidator>
            }
          />
          {/* Default redirect to Ethereum */}
          <Route path="/" element={<Navigate replace to="/ethereum" />} />
        </Routes>
      </BrowserRouter>

        
    </div>
  );
}

export default App;